import { useEffect, useState } from "react"
import { useAppContext } from "@/lib/contexts/appContext"
import fetchPathData from "@/lib/api/fetchPathData"
import { getProps } from "@/lib/component"
import { CartProvider } from "@/components/woocommerce/cartStore"
import { Layout } from "@/components/base/layout"
import { getMemberToken } from "@/lib/helpers/member"
import { getUserTokenWithContext } from "@/lib/helpers/user"
import { initGoogleTagManager } from "@/lib/google-tag-manager"
import { pushNextRoute } from "@/lib/helpers/nextRoute"
import useCookieBot from "@/lib/hooks/useCookieBot"
import Head from "@/lib/head"

const Index = ({ pathData }) => {
  const { tracking } = getProps(pathData.props, "object") ?? {}
  const { meta, resetAppContext } = useAppContext()
  const [firstRequest, setFirstRequest] = useState(true)
  const [hasPushedAfterConsent, setHasPushedAfterConsent] = useState(false)
  const cookieBot = useCookieBot()

  useEffect(() => {
    const { gtmContainerId, cookiebotId } = meta
    if (gtmContainerId) {
      initGoogleTagManager(gtmContainerId, cookiebotId)
    }
    setFirstRequest(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (cookieBot.loading || hasPushedAfterConsent) {
      return
    }

    if (cookieBot.newConsent) {
      pushNextRoute(pathData, firstRequest, tracking?.isLoggedin ?? false)
      setHasPushedAfterConsent(true)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cookieBot.newConsent])

  useEffect(() => {
    resetAppContext()
    pushNextRoute(pathData, firstRequest, tracking?.isLoggedin ?? false)
    setFirstRequest(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathData])

  return (
    <>
      <Head />
      <CartProvider>
        <Layout />
      </CartProvider>
    </>
  )
}

export async function getServerSideProps(context) {
  const path = context?.resolvedUrl ?? "/"
  const token = getMemberToken(context)
  const adminToken = getUserTokenWithContext(context)

  try {
    const pathData = await fetchPathData(
      {
        path,
        isPreview: context.preview && path === context?.previewData?.path
      },
      token ?? adminToken
    )

    if (!pathData) {
      throw new Error("API response error")
    }

    if (pathData.status === 404) {
      context.res.statusCode = 404
    }

    if (pathData.redirect) {
      return {
        redirect: {
          destination: pathData.path,
          permanent: [301, 308].includes(pathData.status)
        }
      }
    }

    return {
      props: { pathData }
    }
  } catch (error) {
    throw new Error("Internal error")
  }
}

export default Index
